<template>
  <div class="history-container" v-loading.fullscreen="loading" element-loading-background="rgba(0, 0, 0, 0.5)" element-loading-text="正在下载...">
    <div class="content-title">预警人员</div>
    <div class="content-item">
      <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
      <div class="content-right">
        <div class="right-title">人员</div>
        <div class="query">
          <MyForm class="search-form" :formOptions="queryForm" :inline="true" label-width="auto"></MyForm>
        </div>
        <MyTable :table-options="tableOptions" border max-height="60vh">
          <template #state="{ row }">
            {{ stateMap[row.state] }}
          </template>
          <template #handler="{ row }">
            <MyButton link icon="Download" @click="click_download(row)">下载报告</MyButton>
          </template>
        </MyTable>
      </div>
    </div>
    <MyPagination :params="paginationParams" :total="total" @get-list="getTesterList" ref="paginationRef" />
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import organizationApi from "@/api/organization";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
import activityApi from "@/api/activity";

const stateMap = {
  '-1': "分析失败",
  0: "未分析",
  1: "正在分析",
  2: "分析完成",
};

const currentUnit = ref({});
const nodeClick = (data) => {
  currentUnit.value = data;
  paginationParams.OrganizationId = data.id;
  getActivityList(data.id);
}

const activityList = ref([]);
const getActivityList = (id) => {
  if(!id){
    return;
  }
  activityApi.getActivityList({
    SkipCount: 0,
    MaxResultCount: 1000,
    OrganizationId: id
  }).then((res) => {
    activityList.value = res.data.items.map(item=>{
      item.label = item.name;
      item.value = item.id;
      return item;
    })
  })
}

const queryForm = reactive({
  itemList: [
    {
      type: "Date",
      label: "日期筛选:",
      prop: "EvaluationDate",
      attrs: {
        type: "daterange",
        startPlaceholder: "开始时间",
        rangeSeparator: "至",
        endPlaceholder: "结束时间",
        placeholder: "请输入关键词",
        valueFormat: "YYYY-MM-DD",
      },
      events: {
        change: (formData,formRef, val) => {
          if(!val){
            formData.StartEvaluationDate = undefined;
            formData.EndEvaluationDate = undefined;
            return;
          }
          formData.StartEvaluationDate = val[0];
          formData.EndEvaluationDate = val[1];
        },
      },
    },
    {
      type: "Input",
      label: "关键字：",
      prop: "Key",
      attrs: {
        placeholder: "请输入学号/手机号",
        // class: ["mgr300"],
      },
    },
    {
      type: "Input",
      label: "组织信息：",
      prop: "StrValue",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "Select",
      label: "活动名称:",
      prop: "Activity",
      options: activityList,
      attrs: {
        placeholder: "请选择",
      },
    },
    {
      type: "Input",
      label: "姓名：",
      prop: "Name",
      attrs: {
        placeholder: "请输入姓名",
      },
    },
    // {
    //   type: "Input",
    //   label: "组织信息：",
    //   prop: "StrValue",
    //   attrs: {
    //     placeholder: "请输入",
    //   },
    // },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
          style: {
            marginLeft: 0,
          }
        },
        events: {
          click(formData) {
            Object.assign(paginationParams,formData)
            paginationParams.refreshKey++
          },
        },
      },
      {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "Refresh",
        },
        events: {
          click(formData,formRef) {
            formRef.resetFields();
            formData.StartEvaluationDate = undefined;
            formData.EndEvaluationDate = undefined;
            Object.assign(paginationParams,formData)
          },
        },
      },
    ],
    {
      type: "Button",
      value: "全部下载",
      attrs: {
        icon: "Download",
        class: ["download"],
      },
      events: {
        click(formData) {
          downloadAll();
        },
      },
    },
  ],
});

const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", minWidth: 60 },
    { label: "活动名称", prop: "activityName" },
    { label: "检测时间", prop: "creationTime" },
    { label: "学号", prop: "numberId" },
    { label: "姓名", prop: "testerName"},
    { label: "电话", prop: "phone"},
    { label: "分析状态", slot_name: "state"},
    { label: "部门/学院", prop: "strValue2" },
    { label: "年级", prop: "strValue3" },
    { label: "班级", prop: "strValue4" },
    { label: "评测结果", type: "slot", slot_name: "handler", width: 200 },
  ],
  tableData: [],
});

// 分页
const paginationParams = reactive({
  IsEvaluation: true,
  OrganizationId: "",
  refreshKey:0
})
const paginationRef = ref(null);
const total = ref(0);
const getTesterList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  organizationApi.getTesterWarning(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items.map(item=>{
      item.organizationName = currentUnit.value.name;
      item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD");
      return item;
    });
  })
}

const click_download = (row) => {
  organizationApi.downloadPeopleReport(row.id).then((res) => {
    window.open(res.data);
  })
}

const loading = ref(false);
const downloadAll = () => {
  // loading.value = true;
  // organizationApi.downloadAllReport(paginationParams).then((res) => {
  //   window.open(res.data);
  // }).finally(()=>{
  //   loading.value = false;
  // })
  if(!currentUnit.value.id){
    return ElMessage.warning("请先选择组织");
  }
  ElMessageBox.prompt('请输入任务名称', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputPattern: /\S/,
    inputValue: '报告生成任务',
    inputErrorMessage: '任务名称不能为空',
  }).then(({ value }) => {
    organizationApi.downloadAllReportTask({
      ...paginationParams,
      taskText: value
    }).then((res) => {
      ElMessage.success("任务创建成功，请稍后前往下载中心查看");
    })
  })
}

</script>

<style lang="scss" scoped>
.content-item{
  display: flex;
  min-height: 60vh;
  .content-right {
    flex: 1;
    overflow: hidden;
    .right-title {
      background: #134e92;
      height: 40px;
      line-height: 40px ;
      color: #66baec;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
    }
    .query {
      background: #03386a;
      padding: 0 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #66baec;
      .search-form{
        padding-top: 20px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        :deep(){
          .el-date-editor, .el-input, .el-select{
            // width: 200px;
            width: 300px;
          }
          .el-form-item:has(.download){
            margin-left: auto;
            margin-right: 0;
          }
          .mgr300{
            margin-right: 300px;
          }
        }
      }
    }
  }
}
</style>